<template>
  <div class="pagination-info" v-if="showInfo">
    <span class="pagination-text">
      {{ startItem }}-{{ endItem }} sur {{ total }}
    </span>
    <span v-if="showItemsPerPage" class="pagination-separator">|</span>
    <Select
      v-if="showItemsPerPage"
      :model-value="itemsPerPage"
      label="Éléments par page"
      @update:model-value="$emit('items-per-page-change', $event)"
      class="pagination-select"
      :options="itemsPerPageOptionsFormatted"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import Select from '../Select.vue'
import { pageSizeLabel } from '../../../composables/useListPreferences.js'

const props = defineProps({
  showInfo: Boolean,
  showItemsPerPage: Boolean,
  startItem: Number,
  endItem: Number,
  total: Number,
  itemsPerPage: Number,
  itemsPerPageOptions: Array
})

defineEmits(['items-per-page-change'])

const itemsPerPageOptionsFormatted = computed(() => {
  return (props.itemsPerPageOptions || []).map(option => ({
    value: option,
    label: pageSizeLabel(option)
  }))
})
</script>

<style scoped>
.pagination-info {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  color: var(--color-text-secondary);
  font-size: var(--font-size-sm);
  flex-wrap: wrap;
  justify-content: center;
}

.pagination-text {
  white-space: nowrap;
}

.pagination-separator {
  color: var(--color-border);
}

.pagination-select {
  min-width: 140px;
}

/* Label du Select : nom accessible requis (FE1-07), mais masqué visuellement
   pour ne pas ajouter de texte visible ici (contexte déjà donné par le total). */
.pagination-select :deep(label) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 768px) {
  .pagination-info {
    flex-direction: column;
    gap: var(--spacing-xs);
  }

  .pagination-separator {
    display: none;
  }
}
</style>
